export default __webpack_public_path__ + "b5070a56bca329093549199bd5423d21.png";